import { connect } from 'react-redux'
import LegalDialog from './LegalDialog'
import { acceptLegalDialog, cancelLegalDialog } from '../../actionCreators'

const mapStateToProps = (state, ownProps) => ({
	open: state.legalDialog
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	onAccept: () => dispatch(acceptLegalDialog()),
	onCancel: () => dispatch(cancelLegalDialog())
})

export default connect(mapStateToProps, mapDispatchToProps)(LegalDialog)



// WEBPACK FOOTER //
// ./src/components/LegalDialog/LegalDialogContainer.js